module.exports = __webpack_public_path__ + "static/images/john-lewis-storybook.545d379b1de351c947f11b1e562e59bb.jpg";